module.exports = __webpack_public_path__ + "img/07.76682693.jpg";